import { render } from "./PointBoard.vue?vue&type=template&id=7607a2ad"
import script from "./PointBoard.vue?vue&type=script&lang=js"
export * from "./PointBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__